import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import "core-js/modules/es6.object.assign.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { createContext, useState, createElement, useContext } from 'react';
import ReactDOM from 'react-dom';
var CarouselContext = createContext(null);
/**
 * This basically takes the items given as props, and exposes them via a
 * shared context interface, so that the other components such as buttons
 * can be used and re-arranged by you but have access to the images,
 * current image and so on.
 */

function Carousel(props) {
  var _useState = useState(props.defaultIndex || 0),
      _useState2 = _slicedToArray(_useState, 2),
      currentIndex = _useState2[0],
      setCurrentIndex = _useState2[1];

  var contextValue = {
    items: props.items,
    currentItem: props.items[currentIndex],
    isNextActionable: props.items.length > 1,
    isPrevActionable: props.items.length > 1,
    next: function next() {
      if (currentIndex + 1 >= props.items.length) {
        setCurrentIndex(0);
      } else {
        setCurrentIndex(currentIndex + 1);
      }
    },
    previous: function previous() {
      if (currentIndex - 1 < 0) {
        setCurrentIndex(props.items.length - 1);
      } else {
        setCurrentIndex(currentIndex - 1);
      }
    }
  };
  return createElement("div", null, createElement(CarouselContext.Provider, {
    value: contextValue
  }, props.children));
}

function ItemRenderer(props) {
  var context = useContext(CarouselContext);
  return createElement("div", null, props.render(context.currentItem, context));
}

var Backdrop = function Backdrop(props) {
  return createElement("div", Object.assign({
    className: "LBFBackdrop"
  }, props), props.children);
};

function Lightbox(props) {
  if (!props.isOpen) {
    return null;
  }

  var backdrop = createElement(Backdrop, {
    onClick: props.onBackdropClick
  }, props.children());
  return ReactDOM.createPortal(backdrop, document.body);
}

function Button(props) {
  return createElement("button", {
    type: "button",
    className: "LBFButton ".concat(props.className),
    onClick: props.onClick
  }, props.children);
}

var ArrowNextIcon = function ArrowNextIcon(props) {
  return createElement("svg", Object.assign({
    viewBox: "0 0 20 34"
  }, props), createElement("path", {
    d: "M1 3l2-2 16 16L3 33l-1-1 15-15L2 2z",
    fill: "#FFF"
  }));
};

function NextButton(props) {
  var context = useContext(CarouselContext);

  if (!context.isNextActionable) {
    return null;
  }

  var handleClick = function handleClick(e) {
    e.stopPropagation();
    context.next();
  };

  return createElement(Button, {
    className: 'LBFNextButton',
    onClick: handleClick
  }, createElement(ArrowNextIcon, null));
}

var ArrowPrevIcon = function ArrowPrevIcon(props) {
  return createElement("svg", Object.assign({
    viewBox: "0 0 20 34"
  }, props), createElement("path", {
    d: "M19 3l-2-2L1 17l16 16 1-1L3 17 18 2z",
    fill: "#FFF"
  }));
};

function PrevButton(props) {
  var context = useContext(CarouselContext);

  if (!context.isPrevActionable) {
    return null;
  }

  var handleClick = function handleClick(e) {
    e.stopPropagation();
    context.previous();
  };

  return createElement(Button, {
    className: 'LBFPreviousButton',
    onClick: handleClick
  }, createElement(ArrowPrevIcon, null));
}

var CloseIcon = function CloseIcon(props) {
  return createElement("svg", Object.assign({
    width: 20,
    height: 20
  }, props), createElement("path", {
    d: "M1 3l1.25-1.25 7.5 7.5 7.5-7.5L18.5 3 11 10.5l7.5 7.5-1.25 1.25-7.5-7.5-7.5 7.5L1 18l7.5-7.5L1 3z",
    fill: "#FFF"
  }));
};

function CloseButton(props) {
  var onClick = props.onClick,
      otherProps = _objectWithoutProperties(props, ["onClick"]);

  return createElement(Button, Object.assign({
    className: 'LBFCloseButton',
    onClick: onClick
  }, otherProps), createElement(CloseIcon, null));
}
/**
 * This renders a <img> tag for the current item, using a number of styles that
 * make sense.
 *
 * // Ensures that if the image is larger than the width, we do not exceed the proportions
 * .img {maxWidth: '100%'}
 *
 * cursor: pointer; // go to next
 *
 * max-height: calc(100vh - 140px);
 */


var Image = 1;
export { Backdrop, Button, Carousel, CarouselContext, CloseButton, Image, ItemRenderer, Lightbox, NextButton, PrevButton };